import type { IconSvgObject } from './types';

const MapPinMinusInsideIcon: IconSvgObject = [
  ["path", { d: "M13.6138 21.367C13.1801 21.773 12.6005 22 11.9972 22C11.3939 22 10.8143 21.773 10.3806 21.367C6.40912 17.626 1.08686 13.4469 3.68236 7.37966C5.08573 4.09916 8.45444 2 11.9972 2C15.54 2 18.9087 4.09916 20.3121 7.37966C22.9043 13.4393 17.5951 17.6389 13.6138 21.367Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.4961 11H8.49609", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default MapPinMinusInsideIcon;
